import { ActionType, TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { IconName } from '@optimus-web/core';
import { sortByDescending } from '@mews-commander/utils';

export function editFormMergeProps(stateProps: $TSFixMe, dispatchProps: $TSFixMe, ownProps: $TSFixMe) {
    const { id } = stateProps;
    const { onDelete, readOnlyForm, ...otherDispatchProps } = dispatchProps;
    const actions = readOnlyForm
        ? []
        : [
              {
                  type: ActionType.Link,
                  text: <LocalizedText textKey={TextKey.Delete} />,
                  icon: IconName.Delete,
                  onClick: () => onDelete(id),
              },
          ];

    return {
        ...stateProps,
        ...ownProps,
        ...otherDispatchProps,
        actions,
    };
}

export const sortByCreatedUtcDescending = sortByDescending('createdUtc');
export const sortByUpdatedUtcDescending = sortByDescending('updatedUtc');
